// extracted by mini-css-extract-plugin
export const active = "RateTabs__active__e2A50";
export const all = "RateTabs__all__UAMyZ";
export const atlasGrotesk = "'AtlasGrotesk'";
export const badgeTextWrapper = "RateTabs__badgeTextWrapper__m0a0G";
export const bold = "700";
export const button = "RateTabs__button__vUiws";
export const buttonWrapper = "RateTabs__buttonWrapper__92key";
export const competitiveBadge = "RateTabs__competitiveBadge__CFpP-";
export const content = "RateTabs__content__LI7h5";
export const count = "RateTabs__count__w3YmV";
export const debtOther = "RateTabs__debt_other__3qe88";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const header = "RateTabs__header__WvjfO";
export const medium = "500";
export const mortgage = "RateTabs__mortgage__jqSf0";
export const rateTabs = "RateTabs__rateTabs__wgvfk";
export const regular = "400";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";
export const slash = "RateTabs__slash__IPAMM";
export const tab = "RateTabs__tab__lEves";
export const tabTitle = "RateTabs__tabTitle__ZnZs5";
export const tabs = "RateTabs__tabs__aNRgC";
export const text = "RateTabs__text__cgbpi";
export const textCenter = "RateTabs__textCenter__PTFow";